import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import PendingBooking from "../../Components/DataTables/PendingBooking";
import Button from "../../Components/UI/Button/Button";
import ButtonWithBG from "../../Components/UI/ButtonMain";
import SearchField from "../../Components/UI/SearchField";
import DashBoardLayout from "../../Layouts/private/DashboardLayout";
// import { SEARCH_PLACEHOLDER } from "../../Utils/Constants";
import { setting_svg } from "../../Utils/SVGListing";

const BookingPending = () => {
  let history = useHistory();
  const [searchValue, setSearchValue] = useState("");

  // To redirect to add page
  const redirectToAdd = () => {
    history.push({
      pathname: "/pending-booking/add-booking",
      state: { label: "Add" },
    });
  };
  return (
    <DashBoardLayout pageTitle="Booking">
      <div className="min-w-full space-y-4">
        {/* <Divider subtitle="Pending Booking" /> */}
        {/* Search and setting */}
        <div className="flex flex-row justify-between ">
          <div className=" flex flex-row space-x-2">
            <div className="min-w-1/4">
              <SearchField
              placeholder="Enter value for searching "
              handleChange={setSearchValue}
              setSearchValue={setSearchValue}
              value={searchValue}
            />
            </div>
            <p className="mt-2 font-bold">Upcoming Buillty No:</p>
          </div>
          <div className="flex flex-row space-x-2  items-start">
            <Button svg={setting_svg}></Button>
            <ButtonWithBG
              handleClick={redirectToAdd}
              theme="primary"
              label="Add Booking"
            />
          </div>
        </div>
      </div>
      <PendingBooking searchValue={searchValue} />
    </DashBoardLayout>
  );
};

export default BookingPending;
